import { Rect } from "./types";
import { Point } from "./Point";
import { getMinMax } from "@shared/common/types/Array";

export class BoundingBox extends Rect {
  /**
   * @param x x-position of the upper left corner of the rectangle.
   * @param y y-position of the upper left corner of the rectangle.
   */
  constructor(width: number, height: number, x: number, y: number) {
    super(x, y, width, height);
  }
  static findFromCoordinates(coordinates: Point[]) {
    if (coordinates.length === 0) {
      return new BoundingBox(0, 0, 0, 0);
    }
    const xs = coordinates.map((i) => i.x);
    const ys = coordinates.map((i) => i.y);
    const [minX, maxX] = getMinMax(xs);
    const [minY, maxY] = getMinMax(ys);
    return new BoundingBox(maxX - minX, maxY - minY, minX, minY);
  }
}
